import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import { ProgressbarModule } from 'ngx-bootstrap';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { AlertModule } from 'ngx-bootstrap/alert';

//import { ChipsModule, InputTextModule } from '../../lib/primeng/primeng';
import { SettingsComponent } from './settings.main';
import { FactorComponent } from './factor.frm';
import { DeliverySettingsComponent } from './delivery.frm';
import {CacheSettingsComponent} from "./cache.frm";

@NgModule({
    declarations: [
        SettingsComponent,
        FactorComponent,
        DeliverySettingsComponent,
        CacheSettingsComponent
    ],
    imports: [BrowserModule, FormsModule, HttpModule, AlertModule.forRoot()],
    providers: [SiteServices],

    bootstrap: [SettingsComponent],
})
export class SettingsModule {}
